import React from 'react';
import LegalDocumentPage from './LegalDocumentPage';
import { LegalDocumentEnum } from '../../interfaces/LegalDocument';

const TermsAndConditionsPage: React.FC = () => {
  return (
    <LegalDocumentPage
      documentType={LegalDocumentEnum.TERMS_AND_CONDITIONS}
      title="Terms and Conditions"
      translationKey="FLEET_TERMS_AND_CONDITIONS"
    />
  );
};

export default TermsAndConditionsPage;
